import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
// import { useNavigate } from "react-router-dom";

//API
import ItemService from "../../../../services/supplier_appCommonService";
import ItemServiceV2 from "../../../../services/customer_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux";
import {
  getPurchaseOrder,
  getSchedulingAgreement,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
// import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/CustomerConstants";
import {
  getCurrentDate,
  isValidNumber,
  validateRequired,
} from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
// import SericesSchedulePO from "../../../../Components/Modal/supplier_app/PO_Collabration/SericesSchedulePO";
import Loader from "../../../../Components/Loader";
import MaterialSelectionModalV5 from "./MaterialSelectionModalV5";
import SericesSchedulePOV5Modal from "./SericesSchedulePOV5Modal";
// import TableDropdownMenu from "../../../../Components/TableDropdownMenu/TableDropdownMenu";

const CreatePOV5 = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Purchase");

  let purchaseDocType = useSelector(
    (state) => state?.purchasing.purchaseDocType,
  );
  let purchaseDocCode = useSelector(
    (state) => state?.purchasing.purchaseDocCode,
  );
  let userData = useSelector((state) => state?.user); // User Details from Store

  const approverBylevel = [
    { id: 2, name: "CFO", code: "CFO", description: "CFO" },
    { id: 3, name: "CEO", code: "CEO", description: "CEO" },
    { id: 1, name: "Nandita Sharma", code: "Nandita", description: "MD" },
    { id: 4, name: "Kartik Sharma", code: "Kartik", description: "MD" },
    { id: 5, name: "Udit Sharma", code: "Udit", description: "MD" },
  ];

  const levelSelection = [
    { id: 1, name: "Level 1", code: "", description: "MD" },
    { id: 2, name: "Level 2", code: "CFO", description: "CFO" },
    { id: 3, name: "Level 3", code: "CEO", description: "CEO" },
    { id: 4, name: "Level 4", code: "Kartik", description: "MD" },
    { id: 5, name: "Level 5", code: "Udit", description: "MD" },
  ];
  // const storageLocationData = [
  //   { id: 1, name: "Sale", code: "SL", description: "Sale" },
  //   { id: 2, name: "Rent", code: "RE", description: "Rent" },
  // ];
  //table dropdown
  // const handleDropdownChange = (data) => {
  //   setPOLineItemsData((prevRows) =>
  //     prevRows.map((row) =>
  //       row.local_id === data.index
  //         ? {
  //             ...row,
  //             [data.name]: data.value,
  //             [data.code]: data.codeValue,
  //             [data.desc]: data.descValue,
  //           }
  //         : row,
  //     ),
  //   );
  // };

  let getPurchaseOrderType = [
    {
      id: "1",
      name: "Packing/Promotional",
      code: "PA",
      description: "Packing/Promotional",
    },
    {
      id: "2",
      name: "Trade",
      code: "TR",
      description: "Trade",
    },
    {
      id: "3",
      name: "Factory",
      code: "FA",
      description: "Factory",
    },
    {
      id: "4",
      name: "Consumable",
      code: "CO",
      description: "Consumable",
    },
    {
      id: "5",
      name: "Repairing",
      code: "RE",
      description: "Repairing",
    },
    {
      id: "6",
      name: "Asset",
      code: "AS",
      description: "Asset",
    },

    {
      id: "7",
      name: "BuyBack",
      code: "BU",
      description: "BuyBack",
    },
    {
      id: "8",
      name: "Packaging",
      code: "PA",
      description: "Packaging",
    },
    {
      id: "9",
      name: "Factory-Label",
      code: "FL",
      description: "Factory-Label",
    },
    {
      id: "10",
      name: "Business-Logistics",
      code: "BL",
      description: "Business-Logistics",
    },
    {
      id: "11",
      name: "Development-Samples",
      code: "DS",
      description: "Development-Samples",
    },
    {
      id: "12",
      name: "Job Work",
      code: "JW",
      description: "Job Work",
    },
    {
      id: "13",
      name: "Development-Services",
      code: "DS",
      description: "Development-Services",
    },
    {
      id: "14",
      name: "Outservice",
      code: "OS",
      description: "Outservice",
    },
  ];
  const [currentDate] = useState(getCurrentDate("default"));
  // JSON Object
  const [formInputs, setFormInputs] = useState({
    manualIndicator: true,
    manualRelease: true,
    initiatorName: userData?.data?.firstName,
    initiator: userData?.data?.userId,
    purchasingDocumentType: purchaseDocType || "",
    purchasingDocumentCode: purchaseDocCode || "",
    version: "V0",
    statusHeader: "In Release",
    vendorCode: "",
    vendorName: "",
    procurementCategory: "",
    purchasingDocumentCategory: "L",
    purchasingDocumentDate: currentDate,
    purchasingOrg: "",
    purchasingGroup: "",
    companyCode: "",
    currency: "INR - Rupee",
    currencyCode: "INR",
    paymentTerms: "",
    incoTerms: "",
    incoTermsLocation: "",
    purchasingDocumentValue: "",
    purchasingRemark: "",
    gateEntryStatus: "Gate Entry Pending",
    qualityCheckStatus: "QC Pending",

    tallyStatusIndicator: "Pending",
    tallyHistory: [],

    headerTextData: [
      {
        itemIndex: "",
        documentId: "",
        documentText: "",
      },
    ],

    ldApplicability: "",
    ldPerDayInPercentage: "",
    downPaymentIndicator: "",
    downPaymentPercentage: "",
    dueDateForDownPayment: "",
    modeOfTransport: "",
    retention: "",

    items: [
      {
        purchasingDocumentItemNr: "",
        itemTextData: [
          {
            itemIndex: "",
            documentId: "",
            documentText: "",
          },
        ],
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        purchaseQuantity: "",
        orderUnitOfMeasure: "",
        orderPriceUnit: "",
        netValue: "",
        deliveryDate: "",
        itemCurrency: "",
        plant: "",
        storageLocn: "",
        taxCode: 0,
        taxAmount: 0,
        buyBack: false,
      },
    ],
    deliveryLoaction: true,
    addressDl:
      "Basement Plot No 37, Electronic City, Sector 18, Udyog Vihar Phase IV, Gurugram - 122015",
    mobileNoDl: "098715 52255",
    gstInDl: "06AAJCM7464L1ZW",
    emailDl: "info@medirent.in",
    triggerWorkflow: true,
  });

  const modalData = {
    title: "PO Creation",
    successMsg: "",
  };

  const [getCurrencyDropdown, setCurrencyDropdown] = useState([]);
  const [getLoader, setLoader] = useState(true);
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const addManualPO = () => {
    setPOLineItemsData((prevRows) => {
      const newRow = {
        local_id:
          prevRows.length > 0
            ? Math.max(...prevRows.map((r) => Number(r.local_id) || 0), 0) + 1
            : 1,
        purchasingDocumentItemNr: String(prevRows.length + 1).padStart(3, "0"),
        itemTextData: [],
        statusItem: "In Release",
        currency: "Rupee",
        currencyCode: "INR",
        materialCode: "",
        materialDescription: "",
        materialGroup: "",
        purchaseQuantity: 1,
        orderUnitOfMeasure: "",
        orderPriceUnit: "",
        unitPrice: "",
        masterUnitPrice: "", // no master for manual rows
        netValue: "",
        deliveryDate: "",
        itemCurrency: "",
        plant: "",
        storageLocation: "Sale", // default
        storageLocn: "Sale", // default
        taxCode: "",
        taxAmount: "",
        buyBack: false,
        buyBackItem: formInputs.buyBack || false,
        services: [],
        schedule: [],
        isManual: true, // flag to identify manual rows
      };

      return [...prevRows, newRow];
    });
  };
  // Inital Create PO
  let POLineItemInitialCol = [
    {
      name: "Document Item Nr ",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      width: "180px",
    },
    /*  {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    }, */
    {
      name: "Material/Service",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="materialCode"
        //   placeholder=""
        //   value={row.materialCode || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={!row.isManual} // ← enabled only for manual rows
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    /* {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: false,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || row?.unit || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) =>
        row.orderPriceUnit || row.orderPriceUnit === 0
          ? Number(row.orderPriceUnit).toFixed(2)
          : "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit ?? row.unitPrice ?? ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="netValue"
        //   placeholder=""
        //   value={row.netValue || 0}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue ?? ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          // disabled={!row.isManual} // ← enabled only for manual rows
          disabled={true}
        />
      ),
      width: "130px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode || "INR",
      width: "130px",
    },
    {
      name: "GST Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   name="taxAmount"
        //   placeholder=""
        //   // value={Math.round(row.taxAmount).toFixed(2) || 0}
        //   value={row.taxAmount || 0}
        //   disabled={true}
        // />
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount ?? ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
          // disabled={!row.isManual}
          disabled={true}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "GST Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode ?? ""}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        // <InputField
        //   className="inputBox mt-1"
        //   type="date"
        //   name="deliveryDate"
        //   placeholder=""
        //   value={row.deliveryDate || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    // {
    //   name: "Plant",
    //   selector: (row) => row.plant || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       // label="Please Enter the Remarks*"
    //       name="plant"
    //       placeholder=""
    //       value={row.plant || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //     />
    //   ),
    //   sortable: false,
    //   width: "200px",
    // },
    {
      name: "Godown",
      selector: (row) => row.storageLocation || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.storageLocation}</p>
        </div>

        // <TableDropdownMenu
        //   index={row?.local_id}
        //   label={"Godown"}
        //   data={storageLocationData}
        //   id={"storageLocation"}
        //   name={"storageLocation"}
        //   code={"storageLocationCode"}
        //   description={"storageLocationDescription"}
        //   onChange={handleDropdownChange}
        //   value={row?.storageLocation}
        //   codeValue={row?.storageLocationCode}
        //   descValue={row?.storageLocationDescription}
        //   // required={true}
        // />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let POLineItemInitialData = [
    // {
    //   local_id: 1,
    //   purchasingDocumentItemNr: 1,
    //   itemTextData: [],
    //   statusItem: "In Release",
    //   currency: getCurrencyDropdown.name || "Rupee",
    //   currencyCode: getCurrencyDropdown.code || "INR",
    //   taxCode: 0,
    //   taxAmount: 0,
    // },
  ];

  // Inital Create Service PO
  let ServicePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      width: "180px",
    },
    /*   {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    }, */
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Service",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.services, "SER")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    /*  {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price",
      selector: (row) =>
        row.orderPriceUnit || row.orderPriceUnit === 0
          ? Number(row.orderPriceUnit).toFixed(2)
          : "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "130px",
    },
    {
      name: "GST Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "GST Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode ?? ""}
          disabled={true}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    // {
    //   name: "Plant",
    //   selector: (row) => row.plant || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       // label="Please Enter the Remarks*"
    //       name="plant"
    //       placeholder=""
    //       value={row.plant || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //     />
    //   ),
    //   sortable: false,
    //   width: "200px",
    // },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocation || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0">{row?.storageLocation}</p>
        </div>
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="storageLocn"
        //   placeholder=""
        //   value={row.storageLocn || ""}
        //   onChange={(event) => handleInputChange(row.local_id, event)}
        // />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let ServicePOLineItemInitialData = [
    /* {
      local_id: 1,
      purchasingDocumentItemNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      currency: getCurrencyDropdown.name || "Rupee",
      currencyCode: getCurrencyDropdown.code || "INR",
      taxCode: 0,
      taxAmount: 0,
    }, */
  ];

  // Inital Create Schedule PO
  let SchedulePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      width: "180px",
    },
    /*   {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showLineItemHeaderText(row.local_id, row.itemTextData)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    }, */
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Schedule",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServicesLineItem(row.local_id, row.schedule, "SE")
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    /*   {
      name: "Material Group",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) =>
        row.orderPriceUnit || row.orderPriceUnit === 0
          ? Number(row.orderPriceUnit).toFixed(2)
          : "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "GST Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "GST Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode ?? ""}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    /*    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: false,
      width: "200px",
    }, */
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      // sortable: false,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  let SchedulePOLineItemInitialData = [
    // {
    //   local_id: 1,
    //   purchasingDocumentItemNr: 1,
    //   itemTextData: [],
    //   statusItem: "In Release",
    //   currency: getCurrencyDropdown.name || "Rupee",
    //   currencyCode: getCurrencyDropdown.code || "INR",
    //   taxCode: 0,
    //   taxAmount: 0,
    // },
  ];

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  // const [isCardVisible5, setCardVisible5] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // const [loading, setLoading] = useState(false);
  const [getLineItemHeaderTextModal, setLineItemHeaderTextModal] =
    useState(false);
  const [getHeaderTextIndex, setHeaderTextIndex] = useState(0);
  const [HeaderTextModel, setHeaderTextModel] = useState(false);
  const [getDataToHeaderText, setDataToHeaderText] = useState([]);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getTaxAmountValue, setTaxAmountValue] = useState(0);
  const [getItemAmountValue, setItemAmountValue] = useState(0);
  const [getPurchaseType, setPurchaseType] = useState(0);

  const [getSelectedLevel, setSelectedLevel] = useState(0);

  // const [getPurchaseCategory, setPurchaseCategory] = useState(0);
  // eslint-disable-next-line
  const [getMatchType, setMatchType] = useState(0);
  // const [getpurchaseGroup, setpurchaseGroup] = useState(0);

  //Services
  const [getServicesLineItemModal, setServicesLineItemModal] = useState(false);
  const [getServicesLineItemIndex, setServicesLineItemIndex] = useState(0);
  const [getServicesLineItemText, setServicesLineItemText] = useState([]);
  const [getServiceTitle, setServiceTitle] = useState("");

  // useEffect(()=>{

  // },[getServicesLineItemText])
  //Schedule
  // const [getScheduleLineItemModal, setScheduleLineItemModal] = useState(false);
  // const [getScheduleLineItemIndex, setScheduleLineItemIndex] = useState(0);
  // const [getScheduleLineItemText, setScheduleLineItemText] = useState([]);

  // Header Text
  const handleHeaderTextLineItemData = (data) => {
    setPOLineItemsData((prevUsers) =>
      prevUsers?.map((item) =>
        item.purchasingDocumentItemNr === getHeaderTextIndex
          ? { ...item, itemTextData: data }
          : item,
      ),
    );
  };

  const normalizeItemNr = (val) => String(val).padStart(3, "0");

  //Service PO and Schedule PO
  // const handleServicePOLineItemData = (data = []) => {
  //   // console.log(">>servicedata",data)
  //   if (!Array.isArray(data)) return;

  //   setPOLineItemsData((prevUsers = []) =>
  //     prevUsers.map((item) => {
  //       if (
  //         normalizeItemNr(item.purchasingDocumentItemNr) !==
  //         normalizeItemNr(getServicesLineItemIndex)
  //       ) {
  //         return item;
  //       }

  //       // SERVICE PO
  //       if (formInputs.purchaseTypeCode === "SER") {
  //         let totalGrossValue = 0;
  //         let orderUnitOfMeasure = item.orderUnitOfMeasure;

  //         data.forEach((service) => {
  //           totalGrossValue += Number(service?.grossValue || 0);
  //           if (service?.orderUnitOfMeasure) {
  //             orderUnitOfMeasure = service.orderUnitOfMeasure;
  //           }
  //         });

  //         return {
  //           ...item,
  //           services: data,
  //           purchaseQuantity: 1,
  //           orderPriceUnit: totalGrossValue,
  //           orderUnitOfMeasure,
  //         };
  //       }

  //       return item;
  //     }),
  //   );
  // };
  const handleServicePOLineItemData = (data = []) => {
    if (!Array.isArray(data)) return;

    setPOLineItemsData((prevUsers = []) =>
      prevUsers.map((item) => {
        if (
          normalizeItemNr(item.purchasingDocumentItemNr) !==
          normalizeItemNr(getServicesLineItemIndex)
        ) {
          return item;
        }

        if (formInputs.purchaseTypeCode === "SER") {
          let totalGrossValue = 0;
          let totalGstValue = 0;
          let totalServiceValue = 0;
          let orderUnitOfMeasure = item.orderUnitOfMeasure;

          const updatedServices = data.map((service) => {
            const qty = Number(service?.serviceQuantity) || 0;
            const unit = Number(service?.unitValue) || 0;

            const serviceValue = qty * unit;
            const gstValue = Number(service?.serviceGstValue) || 0;
            const grossValue = Number(service?.grossValue) || 0;

            totalServiceValue += serviceValue;
            totalGstValue += gstValue;
            totalGrossValue += grossValue;

            if (service?.orderUnitOfMeasure) {
              orderUnitOfMeasure = service.orderUnitOfMeasure;
            }

            return {
              ...service,
              serviceValue, // 👈 add per row
            };
          });

          return {
            ...item,
            services: updatedServices,

            // ✅ Header Level Service Object
            service: {
              serviceGrossValue: totalGrossValue,
              serviceGstValue: totalGstValue,
              serviceValue: totalServiceValue,
            },

            // purchaseQuantity: 1,
            // orderPriceUnit: totalGrossValue,
            // orderUnitOfMeasure,
            purchaseQuantity: 1,
            orderPriceUnit: Number(totalGrossValue.toFixed(2)),
            unitPrice: Number(totalGrossValue.toFixed(2)),
            orderUnitOfMeasure,

          };
        }

        return item;
      }),
    );
  };
  // const handleServicePOLineItemData = (data = []) => {
  //   if (!Array.isArray(data)) return;

  //   setPOLineItemsData((prevUsers = []) =>
  //     prevUsers.map((item) => {
  //       if (
  //         normalizeItemNr(item.purchasingDocumentItemNr) !==
  //         normalizeItemNr(getServicesLineItemIndex)
  //       ) {
  //         return item;
  //       }

  //       if (formInputs.purchaseTypeCode === "SER") {
  //         let totalGrossValue = 0;
  //         let totalGstValue = 0;
  //         let totalServiceValue = 0;
  //         let orderUnitOfMeasure = item.orderUnitOfMeasure;

  //         const updatedServices = data.map((service) => {
  //           const qty = Number(service?.serviceQuantity) || 0;
  //           const unit = Number(service?.unitValue) || 0;
  //           const gstPercent = Number(service?.serviceGst) || 0;

  //           // ✅ BASE VALUE
  //           const serviceValue = qty * unit;

  //           // ✅ GST VALUE (calculated)
  //           const gstValue = (serviceValue * gstPercent) / 100;

  //           // ✅ GROSS VALUE (calculated)
  //           const grossValue = serviceValue + gstValue;

  //           // ✅ TOTALS
  //           totalServiceValue += serviceValue;
  //           totalGstValue += gstValue;
  //           totalGrossValue += grossValue;

  //           if (service?.orderUnitOfMeasure) {
  //             orderUnitOfMeasure = service.orderUnitOfMeasure;
  //           }

  //           return {
  //             ...service,
  //             serviceValue,
  //             serviceGstValue: gstValue,
  //             grossValue,
  //           };
  //         });

  //         return {
  //           ...item,
  //           services: updatedServices,

  //           service: {
  //             serviceGrossValue: totalGrossValue,
  //             serviceGstValue: totalGstValue,
  //             serviceValue: totalServiceValue,
  //           },

  //           purchaseQuantity: 1,
  //           orderPriceUnit: totalGrossValue,
  //           orderUnitOfMeasure,
  //         };
  //       }

  //       return item;
  //     })
  //   );
  // };

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [disabled, setDisabled] = useState(false);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData,
  );
  // eslint-disable-next-line no-unused-vars
  const [getPOLineItemsCol, setPOLineItemsCol] = useState(POLineItemInitialCol);

  const [getVendorDropdownData, setVendorDropdownData] = useState([]);
  const [getVendorDropdown, setVendorDropdown] = useState([]);
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // eslint-disable-next-line
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  // eslint-disable-next-line
  const [getLdperdaypercentage, setLdperdaypercentage] = useState([]);
  // eslint-disable-next-line
  const [getLdApplicability, setLdApplicability] = useState([]);
  // eslint-disable-next-line
  const [getdownPaymentCategory, setdownPaymentCategory] = useState([]);
  // eslint-disable-next-line
  const [getmodeOfTransport, setmodeOfTransport] = useState([]);
  // eslint-disable-next-line
  const [getretention, setretention] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  // const toggleCardVisibility5 = () => {
  //   setCardVisible5(!isCardVisible5);
  // };

  /* Create PO Line Item Header Text Modal Function */
  // eslint-disable-next-line
  const showLineItemHeaderText = (index, data) => {
    setLineItemHeaderTextModal(true);
    setHeaderTextIndex(index);
    setDataToHeaderText(data);
  };
  const hideLineItemHeaderText = () => {
    setLineItemHeaderTextModal(false);
  };

  /* Create Header Text Modal Function */
  // eslint-disable-next-line
  const showsetHeaderText = () => {
    setHeaderTextModel(true);
    setDataToHeaderText();
  };
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };
  // eslint-disable-next-line
  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Text",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
    // {
    //   name: "Delete",
    //   cell: (row, index) => (
    //     <>
    //       <span>
    //         <i
    //           onClick={() => handleDelete(index)}
    //           className="bi bi-trash text-danger fs-3"
    //         ></i>
    //       </span>
    //     </>
    //   ),
    //   width: "10rem",
    // },
  ];

  /* Create Services PO Line Item Modal Function */
  const showServicesLineItem = (index, data, type) => {
    setServicesLineItemModal(true);
    setServicesLineItemIndex(index);
    setServicesLineItemText(data);
    setServiceTitle(type === "SER" ? "Services List" : "Schedule List");
  };
  const hideServicesLineItem = () => {
    setServicesLineItemModal(false);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // Get Dropdown data select
  useEffect(() => {
    if (getDropdownData?.code === "SA") {
      // Schedule Agreement
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setPOLineItemsCol(SchedulePOLineItemInitialCol || []);
      setPOLineItemsData(SchedulePOLineItemInitialData || []);
    } else if (getDropdownData?.code === "SER") {
      // Service

      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        process: "",
        processCode: "",
        processDesc: "",
      }));

      setPOLineItemsCol(ServicePOLineItemInitialCol || []);
      setPOLineItemsData(ServicePOLineItemInitialData || []);
    } else if (getDropdownData?.textField === "companyCode") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.companyCode,
        [getDropdownData?.textCode]: getDropdownData?.companyCodeCode,
        [getDropdownData?.textDesc]: getDropdownData?.companyCodeDesc,
      }));
      getCompanyDetails(getDropdownData?.documentNumber);
    } else if (getDropdownData?.textField === "vendorName") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "purchaseOrderType") {
      // Service
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      if (getDropdownData?.code === "BU") {
        setFormInputs((formInputs) => ({
          ...formInputs,
          buyBack: true,
        }));
      } else {
        setFormInputs((formInputs) => ({
          ...formInputs,
          buyBack: false,
        }));
      }
    } else if (getDropdownData?.code === "MAT") {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,

        ...(getDropdownData?.code === "MAT"
          ? {
              process: "GRN",
              processCode: "GRN",
              processDesc: "GRN",
            }
          : {
              process: "",
              processCode: "",
              processDesc: "",
            }),
      }));

      setPOLineItemsCol(POLineItemInitialCol || []);
      setPOLineItemsData(POLineItemInitialData || []);
    } else if (getDropdownData?.textField === "approverLevel") {
      const level = parseInt(getDropdownData?.name?.replace("Level ", "")) || 0;
      setSelectedLevel(level);

      // Null out approvers beyond the selected level
      const nulledApprovers = {};
      for (let i = level + 1; i <= 5; i++) {
        nulledApprovers[`approverUserId${i}`] = [];
        nulledApprovers[`approverUserId${i}Code`] = "";
        nulledApprovers[`approverUserId${i}Desc`] = "";
      }

      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        ...nulledApprovers,
      }));
    } else if (
      getDropdownData?.textField?.startsWith("approverUserId") &&
      !getDropdownData?.textField?.includes("Code") &&
      !getDropdownData?.textField?.includes("Desc")
    ) {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // const handleInputChange = (local_id, event, type, vat) => {
  //   const { name, value } = event.target;
  //   if (type === "Number" && vat === undefined) {
  //     if (isValidNumber(value)) {
  //       setPOLineItemsData((prevRows) =>
  //         prevRows?.map((row) => {
  //           return row.local_id === local_id
  //             ? {
  //                 ...row,
  //                 [name]: value,
  //                 netValue:
  //                   name === "purchaseQuantity"
  //                     ? (row?.unitPrice ?? row.orderPriceUnit) * value
  //                     : row.purchaseQuantity * value,
  //                 taxAmount:
  //                   (Number(row.taxCode) / 100) *
  //                   (name === "purchaseQuantity"
  //                     ? (row?.unitPrice ?? row.orderPriceUnit) * value
  //                     : row.purchaseQuantity * value),
  //               }
  //             : row;
  //         }),
  //       );
  //     }
  //   } else if (type === "Number" && vat === "VAT") {
  //     if (isValidNumber(value)) {
  //       setPOLineItemsData((prevRows) =>
  //         prevRows?.map((row) =>
  //           row.local_id === local_id
  //             ? {
  //                 ...row,
  //                 [name]: value,
  //                 taxAmount:
  //                   name === "taxCode"
  //                     ? (Number(value) / 100) *
  //                       (Number(row.purchaseQuantity || 0) *
  //                         Number((row?.unitPrice ?? row.orderPriceUnit) || 0))
  //                     : 0,
  //               }
  //             : row,
  //         ),
  //       );
  //     }
  //   } else {
  //     setPOLineItemsData((prevRows) =>
  //       prevRows?.map((row) =>
  //         row.local_id === local_id ? { ...row, [name]: value } : row,
  //       ),
  //     );
  //   }
  //   // getTotalCount()
  // };
  //change-1
  // const handleInputChange = (local_id, event, type, vat) => {
  //   const { name, value } = event.target;

  //   if (type === "Number" && vat === undefined) {
  //     if (isValidNumber(value)) {
  //       setPOLineItemsData((prevRows) =>
  //         prevRows?.map((row) => {
  //           if (row.local_id !== local_id) return row;

  //           // For manual rows — allow direct edit of netValue/taxAmount
  //           // if (row.isManual) {
  //           //   return { ...row, [name]: value };
  //           // }
  //           if (type === "Number" && vat === undefined) {
  //             if (isValidNumber(value)) {
  //               setPOLineItemsData((prevRows) =>
  //                 prevRows?.map((row) => {
  //                   if (row.local_id !== local_id) return row;

  //                   if (row.isManual) {
  //                     return {
  //                       ...row,
  //                       [name]: Number(value), // ✅ FIX HERE
  //                     };
  //                   }

  //                   return {
  //                     ...row,
  //                     [name]: Number(value),
  //                     netValue:
  //                       name === "purchaseQuantity"
  //                         ? (row?.unitPrice ?? row.orderPriceUnit) * value
  //                         : row.purchaseQuantity * value,
  //                     taxAmount:
  //                       (Number(row.taxCode) / 100) *
  //                       (name === "purchaseQuantity"
  //                         ? (row?.unitPrice ?? row.orderPriceUnit) * value
  //                         : row.purchaseQuantity * value),
  //                   };
  //                 }),
  //               );
  //             }
  //           }

  //           // For non-manual rows — auto-calculate
  //           return {
  //             ...row,
  //             [name]: value,
  //             netValue:
  //               name === "purchaseQuantity"
  //                 ? (row?.unitPrice ?? row.orderPriceUnit) * value
  //                 : row.purchaseQuantity * value,
  //             taxAmount:
  //               (Number(row.taxCode) / 100) *
  //               (name === "purchaseQuantity"
  //                 ? (row?.unitPrice ?? row.orderPriceUnit) * value
  //                 : row.purchaseQuantity * value),
  //           };
  //         }),
  //       );
  //     }
  //   } else if (type === "Number" && vat === "VAT") {
  //     if (isValidNumber(value)) {
  //       setPOLineItemsData((prevRows) =>
  //         prevRows?.map((row) => {
  //           if (row.local_id !== local_id) return row;

  //           // For manual rows — allow direct edit
  //           if (row.isManual) {
  //             return { ...row, [name]: value };
  //           }

  //           return {
  //             ...row,
  //             [name]: value,
  //             taxAmount:
  //               name === "taxCode"
  //                 ? (Number(value) / 100) *
  //                   (Number(row.purchaseQuantity || 0) *
  //                     Number((row?.unitPrice ?? row.orderPriceUnit) || 0))
  //                 : 0,
  //           };
  //         }),
  //       );
  //     }
  //   } else {
  //     setPOLineItemsData((prevRows) =>
  //       prevRows?.map((row) =>
  //         row.local_id === local_id ? { ...row, [name]: value } : row,
  //       ),
  //     );
  //   }
  // };
  //change-2
  // const handleInputChange = (local_id, event, type, subType) => {
  //   const { name, value } = event.target;

  //   if (type === "Number" && !isValidNumber(value)) return;

  //   setPOLineItemsData((prevRows) =>
  //     prevRows.map((row) => {
  //       if (row.local_id !== local_id) return row;

  //       // ---------- UPDATE FIELD ----------
  //       const updatedRow = {
  //         ...row,
  //         [name]:
  //           type === "Number" &&
  //           value !== "" &&
  //           !value.endsWith(".") &&
  //           value !== "."
  //             ? Number(value)
  //             : value,
  //       };

  //       // ---------- SAFE VALUES ----------
  //       const qty = Number(updatedRow.purchaseQuantity || 0);
  //       const price = Number(
  //         updatedRow.orderPriceUnit || updatedRow.unitPrice || 0,
  //       );
  //       const taxCode = Number(updatedRow.taxCode || 0);

  //       // ---------- NET VALUE CALC (always recompute if qty or price changes) ----------
  //       let netValue = Number(updatedRow.netValue || 0);

  //       if (name === "purchaseQuantity" || name === "orderPriceUnit") {
  //         netValue = qty * price;
  //         updatedRow.netValue = netValue;
  //       }

  //       // ---------- TAX CALC ----------
  //       // Use the freshly computed netValue (not updatedRow.netValue which may be stale)
  //       if (
  //         name === "taxCode" ||
  //         name === "purchaseQuantity" ||
  //         name === "orderPriceUnit"
  //       ) {
  //         updatedRow.taxAmount = parseFloat(
  //           ((taxCode / 100) * netValue).toFixed(2),
  //         );
  //       }

  //       return updatedRow;
  //     }),
  //   );
  // };
  const handleInputChange = (local_id, event, type, subType) => {
    const { name, value } = event.target;

    if (type === "Number" && !isValidNumber(value)) return;

    setPOLineItemsData((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id !== local_id) return row;

        const updatedRow = {
          ...row,
          [name]:
            type === "Number" &&
            value !== "" &&
            !value.endsWith(".") &&
            value !== "."
              ? Number(value)
              : value,
          // // ✅ Mirror orderPriceUnit → unitPrice for manual rows
          // ...(name === "orderPriceUnit" &&
          // row.isManual &&
          // !value.toString().endsWith(".") &&
          // value !== "."
          //   ? { unitPrice: value === "" ? "" : Number(value) }
          //   : {}),

          // ✅ Mirror orderPriceUnit → unitPrice for ALL rows (keep PO price keys in sync)
          ...(name === "orderPriceUnit" &&
          !value.toString().endsWith(".") &&
          value !== "."
            ? { unitPrice: value === "" ? "" : Number(value) }
            : {}),
        };

        const qty = Number(updatedRow.purchaseQuantity || 0);
        const price = Number(
          updatedRow.orderPriceUnit || updatedRow.unitPrice || 0,
        );
        const taxCode = Number(updatedRow.taxCode || 0);

        let netValue = Number(updatedRow.netValue || 0);

        if (name === "purchaseQuantity" || name === "orderPriceUnit") {
          // netValue = qty * price;
          netValue = Number((qty * price).toFixed(2));
          updatedRow.netValue = netValue;
        }

        if (
          name === "taxCode" ||
          name === "purchaseQuantity" ||
          name === "orderPriceUnit"
        ) {
          updatedRow.taxAmount = parseFloat(
            ((taxCode / 100) * netValue).toFixed(2),
          );
        }

        return updatedRow;
      }),
    );
  };
  // useEffect(() => {
  //   setPOLineItemsData((prevRows) =>
  //     prevRows?.map((row) => {
  //       const quantity = Number(row.purchaseQuantity || 0);
  //       const price = Number((row.unitPrice ?? row.orderPriceUnit) || 0);
  //       const taxPercent = Number(row.taxCode || 0);

  //       const netValue = quantity * price;
  //       const taxAmount = ((taxPercent / 100) * netValue).toFixed(2);

  //       // Avoid unnecessary re-render loop
  //       if (row.netValue === netValue && row.taxAmount === taxAmount) {
  //         return row;
  //       }

  //       return {
  //         ...row,
  //         netValue,
  //         taxAmount,
  //       };
  //     }),
  //   );
  //   // eslint-disable-next-line
  // }, [JSON.stringify(getPOLineItemsData)]);

  // Get Total for SubTotal Pricing Schedule

  // useEffect(() => {
  //   const getItemTotal = getPOLineItemsData?.reduce(
  //     (accumulator, currentValue) =>
  //       accumulator + (currentValue?.netValue || 0),
  //     0,
  //   );
  //   const taxTotalAmount = getPOLineItemsData?.reduce(
  //     (acc, item) =>
  //       acc + Number(String(item?.taxAmount).replace(/,/g, "") || 0),
  //     0,
  //   );

  //   setTaxAmountValue(taxTotalAmount);
  //   setItemAmountValue(getItemTotal);

  //   setSubTotalValue(Number(getItemTotal) + Number(taxTotalAmount));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getPOLineItemsData]);

  useEffect(() => {
    if (formInputs.purchaseTypeCode === "SER") {
      const totalServiceValue = getPOLineItemsData?.reduce(
        (acc, item) => acc + Number(item?.service?.serviceGrossValue || 0),
        0,
      );

      const totalServiceGST = getPOLineItemsData?.reduce(
        (acc, item) => acc + Number(item?.service?.serviceGstValue || 0),
        0,
      );

      const totalServiceGross = getPOLineItemsData?.reduce(
        (acc, item) => acc + Number(item?.service?.serviceValue || 0),
        0,
      );

      // setItemAmountValue(totalServiceGross); // ✅ gross
      // setTaxAmountValue(totalServiceGST); // ✅ gst
      // setSubTotalValue(totalServiceValue); // ✅ base value
      setItemAmountValue(Number(totalServiceGross.toFixed(2))); // ✅ gross
      setTaxAmountValue(Number(totalServiceGST.toFixed(2))); // ✅ gst
      setSubTotalValue(Number(totalServiceValue.toFixed(2))); // ✅ base value
    } else {
      // 🔁 Your existing logic (for material PO)
      const getItemTotal = getPOLineItemsData?.reduce(
        (acc, item) => acc + (item?.netValue || 0),
        0,
      );

      const taxTotalAmount = getPOLineItemsData?.reduce(
        (acc, item) =>
          acc + Number(String(item?.taxAmount).replace(/,/g, "") || 0),
        0,
      );

      // setTaxAmountValue(taxTotalAmount);
      // setItemAmountValue(getItemTotal);
      // setSubTotalValue(Number(getItemTotal) + Number(taxTotalAmount));

      setTaxAmountValue(Number(taxTotalAmount.toFixed(2)));
      setItemAmountValue(Number(getItemTotal.toFixed(2)));
      setSubTotalValue(
        Number((Number(getItemTotal) + Number(taxTotalAmount)).toFixed(2)),
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPOLineItemsData, formInputs.purchaseTypeCode]);
  useEffect(() => {
    getvendorDetials(getVendorDropdown?.id);
  }, [getVendorDropdown]);

  useEffect(() => {
    getMasterDataFunc();
    // if (purchaseDocType) {
    //   getMasterDataFunc();
    // } else {
    //   // navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_LIST);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Load Master Data
  const getMasterDataFunc = async () => {
    // 1
    let obj1 = {};
    await ItemService.getSupplierDatail(obj1).then((item) => {
      if (item?.status === 200) {
        setVendorDropdownData(item?.data);
      } else {
        setVendorDropdownData([]);
        console.log(">> Error: Loading getSupplierDatail");
      }
    });

    // 2
    let obj2 = {
      codeType: "purchaseOrganisation",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setPurchaseOrg(item?.data);
      } else {
        setPurchaseOrg([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      // codeType: "companyCode",
      queryName: "Get_CompanyMaster_List",
      page: 1,
      per_page: 9999,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
    };
    await ItemService.generateCustomerQuery(obj3).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj5 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj6 = {
      codeType: "paymentTerm",
    };
    // await ItemService.getMasterData(obj6).then((item) => {
    //   if (item?.status === 200) {
    //     setpaymentTerm(item?.data);
    //   } else {
    //     setpaymentTerm([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
    await ItemService.getMasterData(obj6).then((item) => {
      if (item?.status === 200) {
        const updatedData = [
          ...item.data,
          {
            codeType: "paymentTerm",
            code: "ADV",
            description: "Advance Payment",
            name: "ADV - Advance Payment",
            id: "ADV",
          },
        ];

        setpaymentTerm(updatedData);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj8 = {
      codeType: "PurchaseDocType",
    };
    await ItemService.getMasterData(obj8).then((item) => {
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    // let obj7 = {
    //   codeType: "paymentTerm",
    // };
    // await ItemService.getMasterData(obj7).then((item) => {
    //   if (item?.status === 200) {
    //     setLdApplicability(item?.data);
    //   } else {
    //     setLdApplicability([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
    // let obj8 = {
    //   codeType: "paymentTerm",
    // };
    // await ItemService.getMasterData(obj8).then((item) => {
    //   if (item?.status === 200) {
    //     setdownPaymentCategory(item?.data);
    //   } else {
    //     setdownPaymentCategory([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
    // let obj9 = {
    //   codeType: "paymentTerm",
    // };
    // await ItemService.getMasterData(obj9).then((item) => {
    //   if (item?.status === 200) {
    //     setmodeOfTransport(item?.data);
    //   } else {
    //     setmodeOfTransport([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
    // let obj10 = {
    //   codeType: "paymentTerm",
    // };
    // await ItemService.getMasterData(obj10).then((item) => {
    //   if (item?.status === 200) {
    //     setretention(item?.data);
    //   } else {
    //     setretention([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
    // let obj11 = {
    //   codeType: "paymentTerm",
    // };
    // await ItemService.getMasterData(obj11).then((item) => {
    //   if (item?.status === 200) {
    //     setLdperdaypercentage(item?.data);
    //   } else {
    //     setLdperdaypercentage([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
    let obj12 = {
      codeType: "PurchaseType",
    };
    await ItemService.getMasterData(obj12).then((item) => {
      if (item?.status === 200) {
        setPurchaseType(item?.data);
      } else {
        setPurchaseType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    // let obj13 = {
    //   codeType: "paymentTerm",
    // };
    // await ItemService.getMasterData(obj13).then((item) => {
    //   if (item?.status === 200) {
    //     setPurchaseCategory(item?.data);
    //   } else {
    //     setPurchaseCategory([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });
    // let obj14 = {
    //   // codeType: "paymentTerm",
    //   codeType: "purchaseGroup",
    // };
    // await ItemService.getMasterData(obj14).then((item) => {
    //   if (item?.status === 200) {
    //     setpurchaseGroup(item?.data);
    //   } else {
    //     setpurchaseGroup([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });

    // let obj15 = {
    //   codeType: "MatchType",
    // };
    // await ItemService.getMasterData(obj15).then((item) => {
    //   if (item?.status === 200) {
    //     setMatchType(item?.data);
    //   } else {
    //     setMatchType([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });

    setLoader(false);
  };

  //all vedore
  const getvendorDetials = async (associateNumber) => {
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    setDisabled(true);

    try {
      let obj2 = {
        userId: associateNumber,
      };

      const item1 = await ItemService.getUserDetail(obj2);

      if (item1?.status === 200) {
        const selectedVendor = item1.data;

        if (selectedVendor) {
          const gstDoc =
            selectedVendor?.certifications?.find(
              (cert) =>
                cert?.documentType &&
                cert.documentType.split(" - ")[0] === "101",
            ) || null;

          setFormInputs((prev) => ({
            ...prev,
            vendorAddress:
              (selectedVendor?.address || "") +
              " " +
              (selectedVendor?.address2 || "") +
              " " +
              (selectedVendor?.city || "") +
              " - " +
              (selectedVendor?.cityPostalCode || ""),
            vendorEmail: selectedVendor.email,
            vendorMobileNo: selectedVendor.mobileNr,
            vendorGSTNo: gstDoc?.documentNumber || "",
          }));
        }
      } else {
        console.log(">> Error: Loading getSupplierDetail");
      }
    } catch (error) {
      console.error(">> API Error:", error);
    }

    toast.dismiss(toastId);
    setDisabled(false);
  };

  useEffect(() => {
    setPOLineItemsData((prevRows) =>
      prevRows?.map((row) => {
        // Skip auto-calculation for manually added rows
        if (row.isManual) return row;

        const quantity = Number(row.purchaseQuantity || 0);
        const price = Number((row.orderPriceUnit ?? row.unitPrice) || 0);
        const taxPercent = Number(row.taxCode || 0);

        // const netValue = quantity * price;
        const netValue = Number((quantity * price).toFixed(2));
        // const taxAmount = ((taxPercent / 100) * netValue).toFixed(2);
        const taxAmount = parseFloat(
          ((taxPercent / 100) * netValue).toFixed(2),
        );
        if (row.netValue === netValue && row.taxAmount === taxAmount) {
          return row;
        }

        return {
          ...row,
          netValue,
          taxAmount,
        };
      }),
    );
    // eslint-disable-next-line
  }, [JSON.stringify(getPOLineItemsData)]);

  // SAVE
  // const handleSave = async () => {
  //   let requiredFields = [];

  //   if (!validateRequired(getVendorDropdown.firstName)) {
  //     requiredFields.push("*Please Select the Vendor");
  //     setErrorFields(requiredFields);
  //     setShowFailureModal(true);
  //     return;
  //   }
  //   if (!validateRequired(formInputs.paymentTerms)) {
  //     requiredFields.push("*Please Select the Payment Terms");
  //     setErrorFields(requiredFields);
  //     setShowFailureModal(true);
  //     return;
  //   }
  //   if (!validateRequired(formInputs.purchaseType)) {
  //     requiredFields.push("*Please Select the Purchase Type");
  //     setErrorFields(requiredFields);
  //     setShowFailureModal(true);
  //     return;
  //   }
  //   if (formInputs?.purchaseTypeCode === "SER") {
  //     const allHaveServices = getPOLineItemsData.every(
  //       (item) => Array.isArray(item.services) && item.services.length > 0,
  //     );

  //     if (!allHaveServices) {
  //       return toast.error(
  //         "At least add one Service for each Price Shedule / Line Item",
  //         {
  //           position: "top-right",
  //           autoClose: 5000,
  //         },
  //       );
  //     }
  //   }

  //   // if (
  //   //   typeof getPOLineItemsData[0]?.materialCode === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.purchaseQuantity === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.orderUnitOfMeasure === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.orderPriceUnit === "undefined" ||
  //   //   typeof getPOLineItemsData[0]?.deliveryDate === "undefined"
  //   // ) {
  //   //   requiredFields.push("*Alteast one PO Line item should be added.");
  //   //   setErrorFields(requiredFields);
  //   //   setShowFailureModal(true);
  //   //   return;
  //   // }

  //   // let lineItem = []
  //   formInputs.items = getPOLineItemsData;
  //   formInputs.vendorCode = getVendorDropdown.id;
  //   formInputs.vendorName = getVendorDropdown.firstName;
  //   formInputs.headerTextData = getHeaderTextSelectedData;
  //   formInputs.purchasingDocumentValue = subTotalValue;
  //   formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
  //   formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
  //   formInputs.currencyCode = getCurrencyDropdown.code;
  //   formInputs.currency = getCurrencyDropdown.codeType;
  //   formInputs.currencyDesc = getCurrencyDropdown.name;

  //   const toastId = toast.loading("Loading...", {
  //     position: "top-right",
  //   });

  //   let obj = {
  //     data: formInputs,
  //   };

  //   setDisabled(true);
  //   await ItemService.addPO(obj).then((item) => {
  //     if (item?.status === 200) {
  //       modalData.successMsg = item?.message;
  //       setModalInfo(modalData);

  //       let materialPO = {
  //         queryName: "getMaterialPO",
  //         module: "PO",
  //       };
  //       let servicePO = {
  //         queryName: "getServicePO",
  //         module: "PO",
  //       };
  //       let schedulingAgreement = {
  //         queryName: "getSchedulingAgreement",
  //         module: "PO",
  //       };

  //       if (formInputs.purchaseTypeCode === "MAT") {
  //         dispatch(getPurchaseOrder(materialPO));
  //       } else if (formInputs.purchaseTypeCode === "SER") {
  //         dispatch(getServicePO(servicePO));
  //       } else if (formInputs.purchaseTypeCode === "SA") {
  //         dispatch(getSchedulingAgreement(schedulingAgreement));
  //       }
  //        onSuccessfullyRegistered();

  //     } else {
  //       toast.error(item?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   });
  //   toast.dismiss(toastId);
  //   setDisabled(false);
  // };
  const handleSave = async () => {
    let requiredFields = [];

    if (!validateRequired(getVendorDropdown.firstName)) {
      requiredFields.push("*Please Select the Vendor");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (!validateRequired(formInputs.paymentTerms)) {
      requiredFields.push("*Please Select the Payment Terms");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (!validateRequired(formInputs.purchaseType)) {
      requiredFields.push("*Please Select the Purchase Type");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (!validateRequired(formInputs.purchaseType)) {
      requiredFields.push("*Please Select the Purchase Type");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    // ✅ ADD HERE — Workflow approver validation
    if (formInputs.triggerWorkflow) {
      if (!getSelectedLevel || getSelectedLevel === 0) {
        requiredFields.push("*Please Select the Approver Level");
        setErrorFields(requiredFields);
        setShowFailureModal(true);
        return;
      }

      for (let i = 1; i <= getSelectedLevel; i++) {
        const selectedCode = formInputs[`approverUserId${i}Code`];
        if (!validateRequired(selectedCode)) {
          requiredFields.push(`*Please Select Approver User Id ${i}`);
          setErrorFields(requiredFields);
          setShowFailureModal(true);
          return;
        }
      }
    }

    if (formInputs?.purchaseTypeCode === "SER") {
      const allHaveServices = getPOLineItemsData.every(
        (item) => Array.isArray(item.services) && item.services.length > 0,
      );

      if (!allHaveServices) {
        return toast.error(
          "At least add one Service for each Price Schedule / Line Item",
          { position: "top-right", autoClose: 5000 },
        );
      }
    }

    // ✅ ADD THIS — validate line items not empty
    if (!getPOLineItemsData || getPOLineItemsData.length === 0) {
      requiredFields.push("*At least one Line Item must be added.");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    if (formInputs?.purchaseTypeCode === "SER") {
      const allHaveServices = getPOLineItemsData.every(
        (item) => Array.isArray(item.services) && item.services.length > 0,
      );

      if (!allHaveServices) {
        return toast.error(
          "At least add one Service for each Price Schedule / Line Item",
          { position: "top-right", autoClose: 5000 },
        );
      }
    }

    if (!formInputs.triggerWorkflow) {
      for (let i = 1; i <= 5; i++) {
        formInputs[`approverUserId${i}`] = null;
        formInputs[`approverUsername${i}`] = null;
      }
    } else {
      for (let i = 1; i <= 5; i++) {
        if (i <= getSelectedLevel) {
          const selectedCode = formInputs[`approverUserId${i}Code`];
          const matchedApprover = approverBylevel.find(
            (a) => a.code === selectedCode,
          );
          formInputs[`approverUserId${i}`] = selectedCode || null;
          formInputs[`approverUsername${i}`] = matchedApprover?.name || null;
        } else {
          formInputs[`approverUserId${i}`] = null;
          formInputs[`approverUsername${i}`] = null;
        }
      }
    }

    // Attach data
    formInputs.items = getPOLineItemsData;
    formInputs.vendorCode = getVendorDropdown.id;
    formInputs.vendorName = getVendorDropdown.firstName;
    formInputs.headerTextData = getHeaderTextSelectedData;
    formInputs.purchasingDocumentValue = subTotalValue;
    formInputs.purchasingDocumentTaxTotalValue = getTaxAmountValue;
    formInputs.purchasingDocumentItemTotalValue = getItemAmountValue;
    formInputs.currencyCode = getCurrencyDropdown.code;
    formInputs.currency = getCurrencyDropdown.codeType;
    formInputs.currencyDesc = getCurrencyDropdown.name;

    const toastId = toast.loading("Loading...", { position: "top-right" });

    setDisabled(true);

    try {
      const obj = { data: formInputs };
      const item = await ItemService.addPO(obj);

      if (item?.status !== 200) {
        toast.error(item?.message || "Please try again !!", {
          position: "top-right",
        });
        return;
      }

      // Success modal
      modalData.successMsg = item?.message;
      setModalInfo(modalData);

      const materialPO = { queryName: "getMaterialPO", module: "PO" };
      const servicePO = { queryName: "getServicePO", module: "PO" };
      const schedulingAgreement = {
        queryName: "getSchedulingAgreement",
        module: "PO",
      };

      if (formInputs.purchaseTypeCode === "MAT") {
        await dispatch(getPurchaseOrder(materialPO));
      } else if (formInputs.purchaseTypeCode === "SER") {
        await dispatch(getServicePO(servicePO));
      } else if (formInputs.purchaseTypeCode === "SA") {
        await dispatch(getSchedulingAgreement(schedulingAgreement));
      }

      onSuccessfullyRegistered();
      setTimeout(() => {
        onSuccessfullyRegistered();
      }, 1000);
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong!", { position: "top-right" });
    } finally {
      toast.dismiss(toastId);
      setTimeout(() => {
        setDisabled(false);
      }, 1100);
    }
  };
  // eslint-disable-next-line
  const addPOItemRow = () => {
    setPOLineItemsData((prevRows) => {
      POLineItemInitialData[0].local_id = prevRows.length + 1;
      POLineItemInitialData[0].purchasingDocumentItemNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...POLineItemInitialData];
    });
  };

  // const removePOItemRow = (local_id) => {
  //   setPOLineItemsData((prevPrograms) =>
  //     prevPrograms.filter((program) => program.local_id !== local_id),
  //   );
  // };
  const reIndexRows = (rows) => {
    return rows.map((row, index) => ({
      ...row,
      local_id: index + 1,
      purchasingDocumentItemNr: String(index + 1).padStart(3, "0"),
    }));
  };
  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevRows) => {
      const filtered = prevRows.filter((row) => row.local_id !== local_id);

      return reIndexRows(filtered);
    });
  };
  //material selection
  const [modalShow, setModalShow] = useState(false);

  /* Modal Function */
  const addProductDetails = () => {
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  // const handleGetSelectedMaterial = (selectedData) => {
  //   if (!Array.isArray(selectedData) || selectedData.length === 0) return;

  //   setPOLineItemsData((prevRows) => {
  //     const startIndex = prevRows.length;

  //     const mappedRows = selectedData.map((item, index) => ({
  //       ...item,
  //       buyBackItem: formInputs.buyBack, // snapshot at selection time
  //       local_id: startIndex + index + 1,
  //       purchasingDocumentItemNr: String(startIndex + index + 1).padStart(
  //         3,
  //         "0",
  //       ),
  //     }));

  //     return [...prevRows, ...mappedRows];
  //   });
  // };
  // const handleGetSelectedMaterial = (selectedData) => {
  //   if (!Array.isArray(selectedData) || selectedData.length === 0) return;

  //   setPOLineItemsData((prevRows) => {
  //     const newRows = [...prevRows, ...selectedData];

  //     return reIndexRows(newRows);
  //   });
  // };

  const handleGetSelectedMaterial = (selectedData) => {
    if (!Array.isArray(selectedData) || selectedData.length === 0) return;

    setPOLineItemsData((prevRows) => {
      // snapshot the master's unit price once, at selection time (read-only reference)
      const stamped = selectedData.map((item) => {
        // master's Vendor Rate is the authoritative unit price
        const masterPrice = item.unitPrice ?? item.orderPriceUnit ?? "";
        return {
          ...item,
          masterUnitPrice: masterPrice, // frozen reference (original master price)
          unitPrice: masterPrice, // normalize both PO price keys at selection
          orderPriceUnit: masterPrice, // so the line never starts out drifted
        };
      });
      const newRows = [...prevRows, ...stamped];

      return reIndexRows(newRows);
    });
  };

  useEffect(() => {
    setPOLineItemsData((prevRows) =>
      prevRows.map((row) => ({
        ...row,
        buyBackItem: formInputs.buyBack,
      })),
    );
  }, [formInputs.buyBack]);
  const getCompanyDetails = async (id) => {
    try {
      const obj = {
        queryName: "Get_CompanyMaster_Details",
        documentNumber: id,
      };

      const res = await ItemServiceV2.generateCustomerQuery(obj);

      if (res?.status === 200 && res?.data) {
        const company = res.data?.[0];
        setFormInputs((prev) => ({
          ...prev,
          addressDl: company?.address + company?.address2,
          mobileNoDl: company?.mobileNr,
          emailDl: company?.contactDetails[0]?.contactEmail,
          gstInDl: company?.gstNumebr,
        }));
        // setCompanyDetails(company);

        // 🔹 Main form
        // setFormInputs(company);

        // // 🔹 Contact Persons
        // setcustomerContactPerson(company.contactDetails || []);

        // // 🔹 Documents
        // setDocumentTypeData(company.certifications || []);

        // // 🔹 Bank Details
        // // setBankDetails(company.bankDetails[0] || []);
        // setBankDetailsData(company.bankDetails[0] || []);

        // // 🔹 Company Profile
        // setCompanyProfile(company.companyProfile || {});
      }
    } catch (error) {
      console.error("Failed to load company details", error);
    }
  };

  const getFilteredApprovers = (currentApproverIndex) => {
    const usedCodes = [1, 2, 3, 4, 5]
      .filter((i) => i !== currentApproverIndex)
      .map((i) => formInputs[`approverUserId${i}Code`])
      .filter(Boolean);

    return approverBylevel.filter((a) => !usedCodes.includes(a.code));
  };
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Purchase Document</h2>
            <p className="subText">Fill Purchase Document Details</p>
            <hr />

            <Loader isLoading={getLoader} className={"text-center"} />

            {!getLoader && (
              <>
                {/*Document Header Details */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HD</span>
                        </Col>
                        <Col xs={12} md={9} lg={9}>
                          <span className="headerTitle">Header Details</span>
                          <span className="subHeaderTitle">
                            Document Description and Details{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        <Row className="pt-2 pb-4">
                          {purchaseDocType && (
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                id="purchasingDocumentType"
                                className="inputBox"
                                label="Document type"
                                name="purchasingDocumentType"
                                code="purchasingDocumentTypeCode"
                                description="purchasingDocumentTypeDesc"
                                placeholder=""
                                value={purchaseDocType} // purchasingDocumentType
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                          )}
                          {!purchaseDocType && (
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="PO Document type"
                                extraLabel="PO Document type"
                                placeholder=""
                                data={getPurchaseDocType}
                                id="purchasingDocumentType"
                                iconClassName="dropdownIcon"
                                name="purchasingDocumentType"
                                code="purchasingDocumentTypeCode"
                                description="purchasingDocumentTypeDesc"
                                setValue={
                                  formInputs?.purchasingDocumentType || []
                                }
                                required={true}
                                getvalue={setDropdownData}
                              />
                            </Col>
                          )}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentDate"
                              className="inputBox"
                              label="Document Date"
                              name="purchasingDocumentDate"
                              placeholder=""
                              type="date"
                              value={formInputs?.purchasingDocumentDate}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="statusHeader"
                              className="inputBox"
                              label="Status"
                              name="statusHeader"
                              placeholder=""
                              value={formInputs?.statusHeader}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="version"
                              className="inputBox"
                              label="Version"
                              name="version"
                              placeholder=""
                              value={formInputs.version}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseType"
                              label="Purchase Type"
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="purchaseType"
                              code="purchaseTypeCode"
                              description="purchaseTypeDesc"
                              setValue={formInputs?.purchaseType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              required={true}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Organization"
                              extraLabel="SAP Purchase organization"
                              placeholder=""
                              data={getPurchaseOrg}
                              id="purchasingOrg"
                              iconClassName="dropdownIcon"
                              name="purchasingOrg"
                              code="purchasingOrgCode"
                              description="purchasingOrgDesc"
                              setValue={formInputs?.purchasingOrg || []}
                              required={true}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Company Code"
                              extraLabel="SAP Company Code"
                              placeholder=""
                              data={getCompanyCode}
                              id="companyCode"
                              iconClassName="dropdownIcon"
                              name="companyCode"
                              code="companyCodeCode"
                              description="companyCodeDesc"
                              setValue={formInputs?.companyCode || []}
                              getvalue={setDropdownData}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseType"
                              label="Purchase Type"
                              placeholder=""
                              data={getPurchaseType}
                              iconClassName="dropdownIcon"
                              name="purchaseType"
                              code="purchaseTypeCode"
                              description="purchaseTypeDesc"
                              setValue={formInputs?.purchaseType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              // required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="purchaseOrderType"
                              label="Purchase Order Type"
                              placeholder=""
                              data={getPurchaseOrderType}
                              iconClassName="dropdownIcon"
                              name="purchaseOrderType"
                              code="purchaseOrderTypeCode"
                              description="purchaseOrderTypeDesc"
                              setValue={formInputs?.purchaseOrderType || []}
                              getvalue={setDropdownData}
                              disabled={false}
                              // required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            {/* Diff logic for this Only */}
                            <ComboboxField
                              className="dropdownOption"
                              label="Vendor"
                              placeholder=""
                              data={getVendorDropdownData}
                              id="vendorName"
                              iconClassName="dropdownIcon"
                              name="vendorName"
                              setValue={getVendorDropdown?.name || []}
                              getvalue={setVendorDropdown}
                              required={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="vendorAddress"
                              className="inputBox"
                              label="Vendor Address"
                              name="vendorAddress"
                              placeholder=""
                              value={formInputs?.vendorAddress || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="vendorEmail"
                              className="inputBox"
                              label="Vendor Email"
                              name="vendorEmail"
                              placeholder=""
                              value={formInputs?.vendorEmail || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="vendorMobileNo"
                              className="inputBox"
                              label="Vendor Mobile"
                              name="vendorMobileNo"
                              placeholder=""
                              value={formInputs?.vendorMobileNo || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="vendorGSTNo"
                              className="inputBox"
                              label="Vendor GST"
                              name="vendorGSTNo"
                              placeholder=""
                              value={formInputs?.vendorGSTNo || ""}
                              disabled={true}
                              // onChange={onInputChange}
                            />
                          </Col>

                          {/*  <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Purchase Group"
                              name="purchasingGroup"
                              data={getpurchaseGroup}
                              id="purchasingGroup"
                              code="purchasingGroupCode"
                              description="purchasingGroupDesc"
                              iconClassName="dropdownIcon"
                              setValue={formInputs?.purchasingGroup || []}
                              getvalue={setDropdownData}
                              placeholder=""
                              disabled={getDisabledStatus}
                            />
                          </Col> */}

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Payment Terms"
                              extraLabel=""
                              placeholder=""
                              data={getpaymentTerm}
                              id="paymentTerms"
                              iconClassName="dropdownIcon"
                              name="paymentTerms"
                              code="paymentTermsCode"
                              description="paymentTermsDesc"
                              setValue={formInputs?.paymentTerms || []}
                              getvalue={setDropdownData}
                              required={true}
                            />
                          </Col>
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="INCOTerms"
                              extraLabel="INCOTerms Code"
                              placeholder=""
                              data={getINCOTerms}
                              id="incoTerms"
                              iconClassName="dropdownIcon"
                              name="incoTerms"
                              code="incoTermsCode"
                              description="incoTermsDesc"
                              setValue={formInputs?.incoTerms || []}
                              getvalue={setDropdownData}
                            />
                          </Col> */}

                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="incoTermsLocation"
                              className="inputBox"
                              label="INCOTerms Location"
                              name="incoTermsLocation"
                              placeholder=""
                              value={formInputs.incoTermsLocation}
                              onChange={onInputChange}
                            />
                          </Col> */}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentValue"
                              className="inputBox"
                              label="Total Item Amount"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={getItemAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentValue"
                              className="inputBox"
                              label="Total GST Amount"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={getTaxAmountValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="purchasingDocumentValue"
                              className="inputBox"
                              label="Total Purchase Value"
                              name="purchasingDocumentValue"
                              placeholder=""
                              value={subTotalValue}
                              onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Currency"
                              placeholder=""
                              data={getcurrency}
                              id="currency"
                              iconClassName="dropdownIcon"
                              name="currency"
                              code="currencyCode"
                              description="currencyDesc"
                              setValue={
                                getCurrencyDropdown?.name || {
                                  code: "INR",
                                  name: "INR-Rupee",
                                }
                              }
                              getvalue={setCurrencyDropdown}
                              disabled={true}
                            />
                          </Col>
                          {/*         <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="exchangeRate"
                              className="inputBox"
                              label="Exchange Rate"
                              name="exchangeRate"
                              placeholder=""
                              value={formInputs.exchangeRate}
                              onChange={onInputChange}
                            />
                          </Col> */}
                          {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Exchange Rate"
                              name="firstName"
                              placeholder=""
                              // value={""}
                              onChange={onInputChange}
                              disabled={getDisabledStatus}
                            />
                          </Col> */}

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="purchasingRemark"
                              className="inputBox"
                              label="Purchasing Info"
                              name="purchasingRemark"
                              placeholder=""
                              value={formInputs?.purchasingRemark || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding  d-flex align-items-center"
                          >
                            <input
                              id="deliveryLoaction"
                              type="checkbox"
                              className="inputBox"
                              label="Delivery Location"
                              name="deliveryLoaction"
                              checked={formInputs?.deliveryLoaction ?? true}
                              onChange={(e) =>
                                setFormInputs((prev) => ({
                                  ...prev,
                                  deliveryLoaction: e.target.checked,
                                }))
                              }
                            />
                            <label
                              htmlFor="deliveryLoaction"
                              className="fw-medium mx-2"
                              style={{ cursor: "pointer" }}
                            >
                              Delivery Location
                            </label>
                          </Col>
                          {formInputs?.deliveryLoaction && (
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <TextAreaField
                                  id="addressDl"
                                  className="inputBox"
                                  label="Address"
                                  name="addressDl"
                                  placeholder=""
                                  value={formInputs?.addressDl}
                                  onChange={onInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="mobileNoDl"
                                  className="inputBox"
                                  label="Mobile No"
                                  name="mobileNoDl"
                                  placeholder=""
                                  value={formInputs?.mobileNoDl}
                                  onChange={onInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="gstInDl"
                                  className="inputBox"
                                  label="GSTIN"
                                  name="gstInDl"
                                  placeholder=""
                                  value={formInputs?.gstInDl}
                                  onChange={onInputChange}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  id="emailDl"
                                  className="inputBox"
                                  label="Email"
                                  name="emailDl"
                                  placeholder=""
                                  value={formInputs?.emailDl}
                                  onChange={onInputChange}
                                />
                              </Col>
                            </Row>
                          )}
                          {formInputs?.purchaseType === "MAT - Material" && (
                            <>
                              {/*    <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Process"
                                id="process"
                                data={processOptions}
                                placeholder=""
                                value={formInputs.process || ""}
                                name="process"
                                code="processCode"
                                description="processDesc"
                                setValue={formInputs?.process || []}
                                getvalue={setDropdownData}                                
                                disabled={getDisabledStatus}
                              />
                            </Col> */}
                              {/* <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              id="match"
                              label="Match"
                              placeholder=""
                              data={getMatchType}
                              iconClassName="dropdownIcon"
                              name="match"
                              code="matchCode"
                              description="matchDesc"
                              setValue={formInputs?.match || []}
                              getvalue={setDropdownData}
                              disabled={false}
                            />
                          </Col> */}
                            </>
                          )}
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding d-flex align-items-center"
                          >
                            <input
                              id="triggerWorkflow"
                              type="checkbox"
                              className="inputBox"
                              name="triggerWorkflow"
                              checked={formInputs?.triggerWorkflow ?? false}
                              onChange={(e) =>
                                setFormInputs((prev) => ({
                                  ...prev,
                                  triggerWorkflow: e.target.checked,
                                }))
                              }
                            />
                            <label
                              htmlFor="triggerWorkflow"
                              className="fw-medium mx-2"
                              style={{ cursor: "pointer" }}
                            >
                              PO Approval
                            </label>
                          </Col>

                          {formInputs?.triggerWorkflow && (
                            <>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="How many approval level is required ?"
                                  extraLabel=""
                                  placeholder=""
                                  data={levelSelection}
                                  id="approverLevel"
                                  iconClassName="dropdownIcon"
                                  name="approverLevel"
                                  code="approverLevelCode"
                                  description="approverLevelDesc"
                                  setValue={formInputs?.approverLevel || []}
                                  getvalue={setDropdownData}
                                  required={true}
                                />
                              </Col>

                              {getSelectedLevel > 0 && (
                                <Row>
                                  {[1, 2, 3, 4, 5]
                                    .filter((i) => i <= getSelectedLevel)
                                    .map((i) => (
                                      <Col
                                        key={i}
                                        xs={12}
                                        md={4}
                                        lg={4}
                                        className="commTopButtonRightLeftPadding"
                                      >
                                        <ComboboxField
                                          label={`Approver Level ${i}`}
                                          extraLabel=""
                                          placeholder=""
                                          data={getFilteredApprovers(i)}
                                          id={`approverUserId${i}`}
                                          iconClassName="dropdownIcon"
                                          name={`approverUserId${i}`}
                                          code={`approverUserId${i}Code`}
                                          description={`approverUserId${i}Desc`}
                                          setValue={
                                            formInputs?.[
                                              `approverUserId${i}`
                                            ] || []
                                          }
                                          getvalue={setDropdownData}
                                          required={true}
                                        />
                                      </Col>
                                    ))}
                                </Row>
                              )}
                            </>
                          )}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Price Shedule / Line Item */}
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">PS</span>
                        </Col>
                        <Col xs={12} md={3} lg={3}>
                          <span className="headerTitle">Price Schedule</span>
                          <span className="subHeaderTitle">
                            Price Shedule / Line Item
                          </span>
                        </Col>

                        <Col
                          xs={12}
                          md={8}
                          lg={8}
                          className="headerButtonAlign"
                        >
                          {/* <Col xs={4} md={2} lg={2} className="">
                            <button className="btnTable">
                              <i className="bi bi-file-excel"></i> Template
                            </button>
                          </Col>
                          */}
                          {formInputs?.purchaseTypeCode === "MAT" && (
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={addManualPO}
                              >
                                Add Manual
                              </button>
                            </Col>
                          )}
                          <Col xs={4} md={2} lg={2} className="">
                            <button
                              className="btnTable"
                              /* onClick={addPOItemRow} */ /* this manual enter */
                              onClick={addProductDetails} // bring from data
                            >
                              <i className="bi bi-plus-lg"></i> Add
                            </button>
                          </Col>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {" "}
                        {/* dynamicDropdown */}
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={getPOLineItemsCol}
                              data={getPOLineItemsData}
                              keyField="local_id"
                              // progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                              // onSelectedRowsChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!getLoader && (
        <>
          <div className="pageFooter mb-4">
            <Row className="rowDirection">
              <Col xs={12} md={2} lg={2} className="pb-2">
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-save"></i> Create
                </button>
              </Col>
              {/* <Col xs={12} md={2} lg={2} className="">
                <button
                  className="btnTable"
                  //  onClick={handleModify}
                >
                  <i className="bi bi-pencil-square"></i> Modify
                </button>
              </Col> */}
            </Row>
          </div>
        </>
      )}

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Header Text"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="POHeaderTextID"
      />

      {/* Price Shedule / Line Item */}
      <HeaderText
        index={getHeaderTextIndex}
        headername="Header Text for Line Item"
        show={getLineItemHeaderTextModal}
        onHide={hideLineItemHeaderText}
        hedertextdata={handleHeaderTextLineItemData}
        showcurrentdata={getDataToHeaderText}
        masterdata="POItemTextID"
      />

      {/* Price Shedule -> Service PO */}
      {/* <SericesSchedulePO
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handleServicePOLineItemData}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs?.purchaseTypeCode}
      /> */}
      <SericesSchedulePOV5Modal
        index={getServicesLineItemIndex}
        headername={getServiceTitle}
        show={getServicesLineItemModal}
        onHide={hideServicesLineItem}
        servicescheduledata={handleServicePOLineItemData}
        showcurrentdata={getServicesLineItemText}
        purchasetype={formInputs?.purchaseTypeCode}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={
          formInputs?.purchaseTypeCode === "MAT"
            ? Constants.CUSTOMER_V5_PURCHASE_ORDER_LIST
            : formInputs.purchaseTypeCode === "SER"
              ? Constants?.CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST
              : formInputs.purchaseTypeCode === "SA"
                ? Constants?.POCOLLABRATION_SCHEDULING_AGREEMENT
                : ""
        }
      />
      <MaterialSelectionModalV5
        show={modalShow}
        onHide={() => hideModal()}
        buyBack={formInputs.buyBack}
        onselectedcatdata={handleGetSelectedMaterial}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};

export default CreatePOV5;
